// media-duration — read a local file's duration from its container
// metadata via a detached <video preload="metadata"> (works for audio
// files too). Resolves null when the browser cannot parse the file
// (unsupported codec, corrupt header) or after a timeout — never throws,
// never blocks the upload.

export function probeMediaDuration(file: Blob, timeoutMs = 8_000): Promise<number | null> {
  if (typeof document === 'undefined' || typeof URL === 'undefined') return Promise.resolve(null);
  return new Promise((resolve) => {
    let url: string | null = null;
    const el = document.createElement('video');
    let settled = false;
    const finish = (value: number | null) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      el.removeAttribute('src');
      try {
        el.load();
      } catch {
        /* ignore */
      }
      if (url) URL.revokeObjectURL(url);
      resolve(value);
    };
    const timer = window.setTimeout(() => finish(null), timeoutMs);
    el.preload = 'metadata';
    el.muted = true;
    el.onloadedmetadata = () => {
      const d = el.duration;
      finish(Number.isFinite(d) && d > 0 ? d : null);
    };
    el.onerror = () => finish(null);
    try {
      url = URL.createObjectURL(file);
      el.src = url;
    } catch {
      finish(null);
    }
  });
}
